import { loadable } from '@change-corgi/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-featured-petitions',
		path: '/admin/featured_petitions',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_featuredPetitions" */ './index'), {
			exportName: 'FeaturedPetitions',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: 'staff',
		},
		frame: true,
	},
];
